<template>
  <v-card 
    flat
    class="rounded-lg ma-1"
  >
    <v-card-title class="d-flex align-center">
      Todas as Requisições
    </v-card-title>

    <v-card-text>
      <div class="d-flex justify-end py-4 px-2 ga-2">
        <v-spacer></v-spacer>
        <v-text-field
          v-model="search"
          density="compact"
          label="Procurar"
          prepend-inner-icon="mdi-magnify"
          variant="solo-filled"
          flat
          hide-details
          single-line
        ></v-text-field>
      </div>
      
      <v-data-table 
        v-model:search="search" 
        :items="requestsAsOptions"
        :headers="headers"
      >
        <template v-slot:[`item.createdAt`]="{ item }">
          {{ formattedDate(item.createdAt) }}
        </template>
        <template v-slot:[`item.priority`]="{ item }">
          <v-chip :color="priorityColor(item)">
            {{ priorityLabel(item) }}
          </v-chip>
        </template>
        <template v-slot:[`item.status`]="{ item }">
          <v-chip :color="statusColor(item)">
            {{ statusLabel(item) }}
          </v-chip>
        </template>
      </v-data-table>
    </v-card-text>

    <v-snackbar
      v-model="snackbar.active"
      :timeout="4000"
      :color="snackbar.color"
      elevation="24"
    >
      {{ snackbar.text }}
    </v-snackbar>
  </v-card>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { PRIORITY_TYPES, REQUEST_STATUS } from '@/helpers/constants/app.constants';

export default {
  name: 'GeneralContent',
  
  data: () => ({
    search: '',
    snackbar: {
      text: '',
      color: '',
      active: false
    }
  }),

  computed: {
    ...mapState('request', ['requests']),
    ...mapState('user', ['allUsers']),

    requestsAsOptions() {
      return this.requests.map(request => ({
        ...request,
        user: this.formattedUser(request),
        requestedAt: this.formattedDate(request.createdAt),
        eta: this.getEta(request)
      }));
    },

    headers() {
      return [
        { title: 'Código', key: 'code' },
        { title: 'Usuário', key: 'user' },
        { title: 'Descrição', key: 'description' },
        { title: 'Requisitado', key: 'requestedAt' },
        { title: 'Prev. Entrega', key: 'eta' },
        { title: 'Prioridade', key: 'priority' },
        { title: 'Status', key: 'status' }
      ]
    },
  },

  mounted() {
    this.initApp();
  },

  methods: {
    ...mapActions(['initApp']),

    getEta(item) {
      const etaItems = item.requestOptions.filter(option => option.eta);
      if (etaItems.length === 0) return 'N/A';
      return new Date(etaItems[0].eta) ? this.formattedDate(etaItems[0].eta) : 'N/A';
    },

    formattedUser(item) {
      const user = this.allUsers.find(user => user.id === item.userId);
      return `${user.firstName} ${user.lastName}`;
    },

    formattedDate(date) {
      return new Date(date).toLocaleDateString('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: '2-digit'
      });
    },
    
    priorityLabel(item) {
      return PRIORITY_TYPES[item.priority].label;
    },

    priorityColor(item) {
      return PRIORITY_TYPES[item.priority].color;
    },
    
    statusLabel(item) {
      return REQUEST_STATUS[item.status].label;
    },
    
    statusColor(item) {
      return REQUEST_STATUS[item.status].color;
    },
    
    snackbarHandler({color, text}) {
      this.snackbar.color = color;
      this.snackbar.text = text;
      this.snackbar.active = true;
    }
  }
}
</script> 